<template>
<div class="default-vue">
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Detail_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Detail_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/src/assets/SpecialDays_Detail_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="result && result.vueSpecialDays && result.vueSpecialDays.SpecialDays && !loading && !error" class="gdlr-color-wrapper gdlr-show-all no-skin">
        <div class="container">
            <article v-for="aSpecialDay in groupedSpecialDaysSessions" :key="aSpecialDay.conferenceIds" class="padding--20">
                <h2 v-if="aSpecialDay.startDate" class="h1 header-font-weight padding--20">
                    {{aSpecialDay.startDate}}
                </h2>
                <div v-for="groupedSpecialDay in aSpecialDay.vueSpecialDays" :key="groupedSpecialDay">
                    <div class="rounded-s shadow-s special-day-box">
                        <a :href="getPermalinkForTerm(groupedSpecialDay.name)" class="text--dark">
                            <h3 v-if="groupedSpecialDay.name" class="h1 title-font-weight">
                                {{groupedSpecialDay.name}}
                            </h3>
                        </a>
                        <p class="descrription-line-height" v-if="groupedSpecialDay.details">
                            {{groupedSpecialDay.details}}
                        </p>
                        <div v-if="groupedSpecialDay.name" class="btn-padding-top">
                            <a :href="getPermalinkForTerm(groupedSpecialDay.name)" :aria-label="groupedSpecialDay.name + 'button link'" class="gdlr-button small with-border light-button custom-primary-button rounded-side-buttons" :class="buttonscolor">
                                {{ $t('toTheSessions') }}
                            </a>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </div>
    <div v-if="error">
        Something went wrong
    </div>
</div>
</template>

<script>
import queryAndMutaionService from '@/services/queryAndMutaionService';
import moment from 'moment'

export default {
    name: 'SpecialDays',
    props: {
        settingsPerm: Object

    },
    components: {},
    data() {
        return {
            SpecialDays: false,
            result: null,
            loading: false,
            error: true,
            buttonscolor: null,
            conferenceBrandId: this.settingsPerm.conferenceBrandId,
            specialdayterms: this.settingsPerm.specialdayterms,
            postMlcEditionData: this.settingsPerm.postMlcEditionData,
            getPermaLink: false,
            specialDaysToDisplay: [],
            groupedSpecialDays: {},
            groupedSpecialDaysSessions: [],
            currentLocationInstanceID: false,
            languageToDisplay: null,
            theMaybeSetPLLCookieValue: window.jQuery.cookie("pll_language"),
            browserLanguage: window.navigator.userLanguage || window.navigator.language,
            wpSiteLanguage: this.settingsPerm.wpSiteLanguage,
            shouldWeFilterByInstance:false,
        }
    },
    created() {
        if (this.conferenceBrandId) {
            let concordData = queryAndMutaionService.getSpecialDaysDisplay(this.conferenceBrandId);
            if (concordData && concordData.result) {
                this.result = concordData.result;
            }
            if (concordData && concordData.loading) {
                this.loading = concordData.loading;
            }
            if (concordData && concordData.error) {
                this.error = concordData.error;
            }
        }
        if (this.theMaybeSetPLLCookieValue) {
            this.languageToDisplay = this.theMaybeSetPLLCookieValue;
        } else if (this.browserLanguage != this.wpSiteLanguage.slice(0, 2)) {
            this.languageToDisplay = this.browserLanguage;
        } else {
            this.languageToDisplay = this.wpSiteLanguage.slice(0, 2);
        }
    },
    beforeUpdate() {
        if (this.result && this.result.vueSpecialDays && this.result.vueSpecialDays.SpecialDays && this.result.vueSpecialDays.SpecialDays.length) {
            let thiz = this;
            let cookie = window.jQuery.cookie("event_location");
            if (cookie && (typeof cookie !== "undefined") && (cookie != "") && (cookie != "all")) {
                Object.values(this.settingsPerm.postMlcEditionData).forEach(function (aEdition) {
                    if (cookie == aEdition.identifier) {
                        thiz.shouldWeFilterByInstance = true;
                        thiz.currentLocationInstanceID = aEdition.edition_identifier;
                    }
                })
            }
        }

        let filteredDays;
        let specialDaysFilteredByDay = [];
        if (this.shouldWeFilterByInstance && this.currentLocationInstanceID) {
            filteredDays = this.result.vueSpecialDays.SpecialDays.filter(aspecialDay =>{
                if (aspecialDay && aspecialDay.conferenceIds && aspecialDay.conferenceIds.includes(this.currentLocationInstanceID)) {
                    return aspecialDay;
                }
            })
        }else{
            let groupedSpecialDaysByName = this.result.vueSpecialDays.SpecialDays.reduce((result, item) => {
                (result[item.name] = result[item.name] || []).push(item);
                return result;
            }, {});
            Object.entries(groupedSpecialDaysByName).forEach(aGroupSD => {
                if (aGroupSD && aGroupSD.length) {
                    if (aGroupSD[1] && aGroupSD[1].length && aGroupSD[1].length  > 1) {
                        aGroupSD[1].sort((a,b) => ( moment(b.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') - moment(a.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x')));
                        specialDaysFilteredByDay.push( aGroupSD[1][0]);
                  
                    }else if(aGroupSD[1] && aGroupSD[1].length && aGroupSD[1].length  == 1){
                        aGroupSD[1].forEach(singleGroupsSD => {
                            specialDaysFilteredByDay.push(singleGroupsSD);
                        })
                    }
                }
            })
            specialDaysFilteredByDay.sort((a,b) => ( moment(a.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') - moment(b.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x')));
            filteredDays = specialDaysFilteredByDay;
        }
       filteredDays.sort((a,b) => ( moment(a.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x') - moment(b.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('x')));
       filteredDays.forEach(aSpecialDay => {
            if (aSpecialDay.localizedStartDate) {
                aSpecialDay = Object.assign({
                    formatedStartDate: moment(aSpecialDay.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('dddd | MMMM d, YYYY')
                }, aSpecialDay)
                if (this.languageToDisplay == 'de') {
                    moment.locale(this.languageToDisplay);
                    aSpecialDay.formatedStartDate = moment(aSpecialDay.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('dddd | DD. MMMM  YYYY')
                } else {
                    moment.locale(this.languageToDisplay);
                    aSpecialDay.formatedStartDate = moment(aSpecialDay.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('dddd | MMMM DD, YYYY')
                }
                if (aSpecialDay.formatedStartDate) {
                    let doWeFindMatching = this.groupedSpecialDaysSessions.find((aGroupDay) => {
                        if (aGroupDay && aGroupDay.startDate && aGroupDay.startDate == aSpecialDay.formatedStartDate) {
                            return true;
                        }
                    })
                    if (doWeFindMatching) {
                        this.groupedSpecialDaysSessions.forEach(aGroup => {
                            if (aGroup && aGroup.startDate == aSpecialDay.formatedStartDate) {
                                aGroup.vueSpecialDays.push(aSpecialDay)
                            }
                        });
                    } else {
                        this.groupedSpecialDaysSessions.push({
                            "startDate": aSpecialDay.formatedStartDate,
                            "vueSpecialDays": [aSpecialDay]
                        })
                    }

                }
            }
        });
},
methods: {
    getPermalinkForTerm(termName) {
        if (termName) {
            let doWeFindTermByThisName = Object.values(this.specialdayterms).filter(aTerm => {
                if (aTerm && aTerm.name && termName && aTerm.name.toLowerCase().trim() == termName.toLowerCase().trim()) {
                    return aTerm;
                }
            });
            if (doWeFindTermByThisName && doWeFindTermByThisName.length) {
                return doWeFindTermByThisName[0].permalink;
            } else {
                return termName.toLowerCase().trim().replaceAll(' ', '-');
            }
        }
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.btn-padding-top {
    padding-top: 24px;
}

.special-day-box {
    padding: 25px;
    margin-bottom: 20px;
}

.header-font-weight {
    font-weight: 700;
}

.title-font-weight {
    font-weight: 400;
}

.padding--20 {
    padding-bottom: 20px;
}

.text--dark {
    color: black;
}

.descrription-line-height {
    line-height: 1.5;
}
</style>
